<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title"><i>Contents</i></p>
<p class="toc"><a href="#/xhtml/08_Foreword"><i>Foreword</i></a></p>
<p class="toc"><a href="#/xhtml/09_Acknowledgements"><i>Acknowledgements</i></a></p>
<p class="toc"><a href="#/xhtml/10_Introduction"><i>Introduction</i></a></p>
<p class="toc1"><a href="#/xhtml/10_Introduction#h1.1">The Allied Convoy System</a></p>
<p class="toc1"><a href="#/xhtml/10_Introduction#h1.2">Balance Sheet of the U-boat War in the Second World War</a></p>
<p class="toc1"><a href="#/xhtml/10_Introduction#h1.3">German U-boats of World War II</a></p>
<p class="toc1"><a href="#/xhtml/10_Introduction#h1.4">The Commander of <i>U-604</i></a></p>
<p class="toc1"><a href="#/xhtml/10_Introduction#h1.5">The crew of <i>U-604</i></a></p>
<p class="toca"><span href="#/xhtml/11_Chapter01" title="Link target outside of Sample">From Building Yard to First Patrol</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter02" title="Link target outside of Sample">The First War Patrol</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter03" title="Link target outside of Sample">Brest: the New Home for <i>U-604</i></span></p>
<p class="toc"><span href="#/xhtml/14_Chapter04" title="Link target outside of Sample">The Second War Patrol</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample">U-boat Recreation Centre at Trevarez, Chateauneuf de Fou</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter06" title="Link target outside of Sample">The Third War Patrol</span></p>
<p class="toc"><span href="#/xhtml/17_Chapter07" title="Link target outside of Sample">The Fourth War Patrol</span></p>
<p class="toc"><span href="#/xhtml/18_Chapter08" title="Link target outside of Sample">The Fifth War Patrol</span></p>
<p class="toc"><span href="#/xhtml/19_Chapter09" title="Link target outside of Sample">The Sixth War Patrol</span></p>
<p class="toc"><span href="#/xhtml/20_Chapter10" title="Link target outside of Sample">The Return Home from the Sixth War Patrol</span></p>
<p class="toc"><span href="#/xhtml/21_Chapter11" title="Link target outside of Sample">The New Boat <i>U-873</i></span></p>
<p class="toc"><span href="#/xhtml/22_Chapter12" title="Link target outside of Sample">Postscript</span></p>
<p class="toca"><span href="#/xhtml/23_Chapter13" title="Link target outside of Sample"><i>The Emblems of</i> U-604</span></p>
<p class="toc"><span href="#/xhtml/24_List_of_Crewmen" title="Link target outside of Sample"><i>List of Crewmen of</i> U-604</span></p>
<p class="toc"><span href="#/xhtml/25_Notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc"><span href="#/xhtml/26_References" title="Link target outside of Sample"><i>References</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?6cf123bb